import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useStoreValue } from '../../store';
import { isRouteAllowed, DEFAULT_REDIRECT } from '../../config/routeAccessControl';
import LoadingSpinner from '../LoadingSpinner';

const CompanyStatusGuard = () => {
    const location = useLocation();
    const role = useStoreValue('getRole');
    const companyStatus = useStoreValue('getCompanyStatus');
    const getUserWithCompanyStatus = useStoreValue('getUserWithCompanyStatus');
    const hasCompanies = useStoreValue('hasCompanies');
    const isInitialAuthLoading = useStoreValue('isInitialAuthLoading');

    // Show loading spinner during initial auth (prevents flash)
    if (isInitialAuthLoading) {
        return <LoadingSpinner />;
    }

    // Check if current route is allowed
    const allowed = isRouteAllowed(location.pathname, companyStatus, role, hasCompanies);

    if (!allowed) {
        // No companies → redirect to /primo-accesso
        if (!hasCompanies && location.pathname !== '/primo-accesso') {
            return <Navigate to="/primo-accesso" replace />;
        }

        // Special case: User has companies but trying to access /primo-accesso
        if (hasCompanies && location.pathname === '/primo-accesso') {
            // Redirect based on company status
            if (companyStatus === 'APPROVED') {
                return <Navigate to="/" replace/>; // Active → dashboard
            } else {
                if (getUserWithCompanyStatus === 'PENDING') {
                    return <Navigate to="/profilo-aziendale" replace/>;
                } else {
                    return <Navigate to={DEFAULT_REDIRECT} replace />; // Pending/Evaluation → profile
                }
            }
        }

        // Has companies but route not allowed → redirect to /profilo-aziendale
        return <Navigate to={DEFAULT_REDIRECT} replace />;
    }

    return <Outlet />;
};

export default CompanyStatusGuard;
